module.exports = __webpack_public_path__ + "static/media/save-html.3ad8ceb2.png";